import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import AboutUsSiteInnerContainer from 'components/about-us/AboutUsSiteInnerContainer';
import { MoreWaysToWin } from 'components/dashboard/MoreWaysToWin';
import { DaymadeDesignSystemPreviewComponentInfo } from '.';

const ComponentPreview = () => {
  return (
    <AboutUsModule background="grey">
      <AboutUsSiteContainer>
        <h3 className="aboutUsTypographyHeaderLarge">More ways to win</h3>
        <p>
          A component that shows upcoming draws and raffles in Token Town as
          used in dashboard. It is designed to fill its container.
        </p>
        <AboutUsSiteInnerContainer background="white" borderRadius withPadding>
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
            <MoreWaysToWin />
          </div>
        </AboutUsSiteInnerContainer>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'More ways to win',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
